import { TAvailableConfigValues } from '@customTypes/common';

export interface IDroppedFramesEstimatorConfig {
  resetHistoryTimeout: number;
  optimalDroppedFramesFraction: number;
  minimalFramesPlayed: number;
}

export const defaultDroppedFramesEstimatorConfig: IDroppedFramesEstimatorConfig = {
  resetHistoryTimeout: 5 * 60 * 1000,
  optimalDroppedFramesFraction: 0.1,
  minimalFramesPlayed: 200,
};

export const availableDroppedFramesEstimatorConfigValues: TAvailableConfigValues<IDroppedFramesEstimatorConfig> = {};
